import english from './english';
import german from './german';

export default { english, german };



// WEBPACK FOOTER //
// ./src/lib/translations/index.js